import Blazy from 'blazy';

export default new Blazy({
    selector: '.b-lazy:not(.b-loaded)',
    breakpoints: [
        { width: 575, src: 'data-src-sm' },
        { width: 767, src: 'data-src-md' },
        { width: 991, src: 'data-src-lg' },
        { width: 1199, src: 'data-src-xl' },
    ],
    success(el) {
        el.style.filter = null;
    }
});


// WEBPACK FOOTER //
// ../default-js/js/global/blazy.js